<script>
import { GlobalBus } from '@services/bus'

export default {
  name: 'TheSnackModal',
  data() {
    return {
      show: false,
      button: true,
      color: '',
      text: '',
      timeout: 8000,
      timeoutToClose: null,
      colorsMap: {
        error: {
          icon: 'close-circle',
          color: 'danger', // #EB5757
        },
        warning: {
          icon: 'warning-status',
          color: 'warning-new', // #E0AF00
        },
        success: {
          icon: 'check-circle',
          color: 'success', // #56AF79
        },
      },
      pendingSnack: null,
    }
  },
  computed: {
    modalIconName() {
      return this.colorsMap[this.color]
        ? this.colorsMap[this.color].icon
        : 'check-circle'
    },
    modalIconColor() {
      return this.colorsMap[this.color]
        ? this.colorsMap[this.color].color
        : 'success'
    },
    showIcon() {
      return this.colorsMap[this.color]
    },
  },
  created() {
    GlobalBus.$on('show-snack-modal', this.showNext)
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  },
  beforeDestroy() {
    GlobalBus.$off('show-snack-modal', this.showNext)
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    this.clearTimeoutOnly()
  },
  methods: {
    onVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        if (this.show) {
          this.pendingSnack = {
            button: this.button,
            color: this.color,
            text: this.text,
            timeout: this.timeout,
          }
          this.clearTimeoutAndHide()
        } else {
          this.pendingSnack = null
        }
      } else if (document.visibilityState === 'visible') {
        if (this.pendingSnack) {
          this.updateModalState(this.pendingSnack)
          this.setFocus()
          this.startTimeout()
          this.removeFromQueue(this.pendingSnack)
          this.pendingSnack = null
        }
      }
    },
    showNext() {
      if (this.show) return

      this.clear()

      const snacks = this.$store.getters['feedback/nextSnackModal']
      if (snacks && snacks.length) {
        const snackModal = { ...snacks[0] }

        if (document.visibilityState === 'hidden') {
          this.pendingSnack = snackModal
        } else {
          this.updateModalState(snackModal)
          this.setFocus()
          this.startTimeout()
          this.removeFromQueue(snackModal)
        }
      }
    },
    startTimeout() {
      this.timeoutToClose = setTimeout(() => {
        this.close()
      }, this.timeout)
    },
    setFocus() {
      if (document.visibilityState !== 'visible') return

      this.$nextTick(() => {
        setTimeout(() => {
          const dialog =
            this.$refs.dialogSnackModal && this.$refs.dialogSnackModal.$el
          if (dialog) {
            dialog.setAttribute('tabindex', '-1')
            dialog.focus()
          }
        }, 300)
      })
    },
    removeFromQueue(snackModal) {
      this.$store.dispatch('feedback/removeFirstSnackModal', snackModal)
    },
    clear() {
      this.clearTimeoutOnly()
      this.show = false
      this.button = true
      this.color = ''
      this.text = ''
      this.timeout = 4000
    },
    close() {
      if (!this.show) return

      this.clearTimeoutAndHide()
      this.scheduleNextModal()
    },
    onDialogChange(value) {
      if (!value) {
        this.clearTimeoutAndHide()
        this.scheduleNextModal()
      }
    },
    clearTimeoutAndHide() {
      this.clearTimeoutOnly()
      this.show = false
    },
    clearTimeoutOnly() {
      clearTimeout(this.timeoutToClose)
      this.timeoutToClose = null
    },
    scheduleNextModal() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.showNext()
        }, 200)
      })
    },
    updateModalState(modalData) {
      this.show = true
      this.button = modalData.button
      this.color = modalData.color
      this.text = modalData.text
      this.timeout = modalData.timeout
    },
  },
}
</script>

<template>
  <div class="v-application">
    <v-dialog
      ref="dialogSnackModal"
      v-model="show"
      max-width="400px"
      @input="onDialogChange"
    >
      <v-card class="snack-modal-card">
        <v-btn v-if="button" icon small class="close-button" @click="close">
          <icon-svg name="close" size="15" color="#8e8e8e" />
        </v-btn>

        <v-card-text class="pa-0 px-4">
          <div v-if="showIcon" class="mb-4">
            <icon-svg size="40" :name="modalIconName" :color="modalIconColor" />
          </div>

          <span v-if="text" class="modal-text">
            {{ text }}
          </span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="sass" scoped>
.close-button
  elevation: 1
  z-index: 4
  position: absolute
  right: 12px
  top: 12px
  color: #8e8e8e !important

.modal-text
  font-family: 'Geist', sans-serif
  font-weight: 400
  font-style: normal
  font-size: 16px
  line-height: 20px
  letter-spacing: 0px
  text-align: center
  color: #030309
  display: block

.snack-modal-card
  border-radius: 8px !important
  background-color: #EEEEEE !important
  min-height: 200px
  display: flex
  align-items: center
</style>
